import { P2GText } from '@parcel2go/core-ui';
import { useTenant } from '@parcel2go/npm-p2g-app';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

type props = {
  text: string;
  translationKey: string;
  values?: { [key: string]: string };
};

export const OnboardingTitle = ({ text, translationKey, values }: props) => {
  const { tenant } = useTenant();
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <P2GText variant="h1">
      <Trans
        i18nKey={translationKey}
        t={t}
        defaults={text}
        values={values}
        components={{
          span: tenant.includes('PARCEL2GO') ? <span style={{ color: '#27ce5a', fontStyle: 'italic' }} /> : <span />
        }}
      />
    </P2GText>
  );
};
